import { Component, Input, input, output } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'command-button',
    templateUrl: './commandbutton.component.html',
    styleUrls: ['./commandbutton.component.scss'],
    standalone: true,
    imports: [NgStyle]
})
export class CommandButtonComponent {

  readonly text = input<string>(undefined);
  readonly title = input<string>(undefined);
  readonly hideOnMobile = input<boolean>(false);
  readonly hide = input<boolean>(false);
  readonly enabled = input<boolean>(true);
  readonly leftSeparator = input<number>(0);
  readonly rightSeparator = input<number>(0);
  readonly iconClasses = input<string[]>(undefined);
  readonly formatClass = input<string>(undefined);
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() badgeCount: number = 0;

  readonly commandClick = output<any>();
  
  constructor() { }

  buttonClick() {
     // TODO: The 'emit' function requires a mandatory any argument
     this.commandClick.emit(null);
  }

  calculateSeparators() {
    let styles = {};

    const leftSeparator = this.leftSeparator();
    if(leftSeparator) {
        styles["margin-left"] = `${leftSeparator * 45}px`;
    }

    const rightSeparator = this.rightSeparator();
    if(rightSeparator) {
        styles["margin-right"] = `${rightSeparator * 45}px`;
    }

    return styles;
  }

}
